export default {"src":"/_next/static/media/re-logo-abc-white-shadow.878cc0e0.svg","height":195,"width":211,"blurWidth":0,"blurHeight":0};